// @flow
import styled from 'styled-components';

export const SpinnerContainer = styled.div`
    justify-content: center;
    display: flex;
    width: 100%;
    height: 100%;
`;

export const PickerColonContainer = styled.div`
    align-items: center;
    display: flex;
    flex: 1 0 0rem;
    font-weight: bold;
    justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/time-spinner/styles.js